import { MoonOutlined, SunOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import { useColorScheme } from './color-scheme';

export function ColorSchemeToggle() {
  const { scheme, toggle } = useColorScheme();
  const isDark = scheme === 'dark';

  return (
    <Tooltip title={isDark ? 'Mudar para o modo claro' : 'Mudar para o modo escuro'}>
      <Button
        type="text"
        aria-label={isDark ? 'Mudar para o modo claro' : 'Mudar para o modo escuro'}
        icon={isDark ? <SunOutlined /> : <MoonOutlined />}
        onClick={toggle}
      />
    </Tooltip>
  );
}
